export enum ChartPeriods {
    week = 7,
    month = 30,
    months_3 = 90,
    months_6 = 180,
    year = 365,
}
